/** biome-ignore-all lint/style/useNamingConvention: GA4 reserved param names */
import { classifyChannel } from '@repo/config';
import { readAttributionFromCookie } from './attribution/read-attribution-from-cookie';
import { ga4GtagAdapter } from './ga4-gtag-adapter';
import { pageContextFromPathname } from './page-context-from-pathname';

function currentChannel(): string {
  const cookie = readAttributionFromCookie();
  if (cookie?.channel) {
    return cookie.channel;
  }
  let referrerHost: string | null = null;
  try {
    referrerHost = document.referrer ? new URL(document.referrer).host.slice(0, 200) : null;
  } catch {
    referrerHost = null;
  }
  return classifyChannel({ referrerHost });
}

export function trackPageView(pathname: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  const context = pageContextFromPathname(pathname);
  ga4GtagAdapter.trackScreen(pathname, {
    page_template: context.template,
    page_phrase: context.phrase ?? '',
    channel: currentChannel(),
  });
}
